import { Component, type ErrorInfo, type ReactNode } from "react"

export default class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() { return { failed: true } }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Atlas interface failed", error, info)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return <main className="min-h-screen bg-[#08090d] text-[#f0f1f5] flex items-center justify-center p-6"><div className="surface max-w-md p-7 text-center"><h1 className="heading-display text-2xl mb-3">Atlas could not open this page.</h1><p className="text-sm text-[#9ca3af] mb-5">Your work is safe. Refresh the page; if the problem continues, return to the homepage.</p><div className="flex gap-2 justify-center"><button className="btn-primary" onClick={() => location.reload()}>Refresh</button><a className="btn-subtle" href="/">Homepage</a></div></div></main>
  }
}
